import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { CommonUiComponentsSpinnerComponent } from '@cdw-ae/common-ui-components-spinner';

@Component({
  selector: 'lib-preview-icon',
  templateUrl: './preview-icon.component.html',
  styleUrls: ['./preview-icon.component.scss'],
  standalone: true,
  imports: [MatTooltipModule, MatIconModule, CommonUiComponentsSpinnerComponent],
})
export class PreviewIconComponent<T = unknown>
  implements ICellRendererAngularComp
{
  public tooltipText = '';
  public useMatIcon = false;
  public customTextColor?: string;
  public isStale = false;
  public isUpdating = false;

  public agInit(params: ICellRendererParams<T>): void {
    const data = params.data as Record<string, unknown>;
    // biome-ignore lint/complexity/useLiteralKeys: bracket notation required by noPropertyAccessFromIndexSignature
    this.isStale = !!data?.['isStale'];
    // biome-ignore lint/complexity/useLiteralKeys: bracket notation required by noPropertyAccessFromIndexSignature
    this.isUpdating = !!data?.['isUpdating'];
    // Get previewField and optional previewFieldLabel from context
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const previewField: string | undefined = params.context?.previewField;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const previewFieldLabel: string | undefined = params.context?.previewFieldLabel;

    // Get field value from row data
    if (previewField && data?.[previewField]) {
      const fieldValue = data[previewField];
      const formattedValue = typeof fieldValue === 'string' || fieldValue instanceof Date
        ? this.formatDate(fieldValue as string | Date)
        : String(fieldValue);

      // Use custom label if provided, otherwise use the field name
      const displayLabel = previewFieldLabel || previewField;

      // Use line break for multi-line tooltip
      this.tooltipText = `${displayLabel}: ${formattedValue}
Click to see more details`;
    } else {
      // Don't show tooltip when there's no preview data
      this.tooltipText = '';
    }

    // Get properties from grid context
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    this.useMatIcon = params.context?.useMatIcon ?? false;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    this.customTextColor = params.context?.customTextColor;
  }

  // this method is needed to fulfill the ICellRendererAngularComp interface
  public refresh(): boolean {
    return false;
  }

  private formatDate(date: string | Date): string {
    try {
      const dateObj = typeof date === 'string' ? new Date(date) : date;
      return dateObj.toLocaleString();
    } catch {
      return String(date);
    }
  }
}
